<script>
  import { format } from 'svelte-i18n';
  import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, Collapse } from '@sveltestrap/sveltestrap';

  import { DebugReport } from '@client/components/debug-report';
  import { Icon } from '@client/components/icon';

  import { classnames } from '@client/utils/classnames';

  export let active = false;
  export let disabled = false;
  export let nextDisabled = false;
  export let summary = undefined;
  export let title;
  export let nextLabel = undefined;
  export let executionStatus = undefined;
  export let debugReport = undefined;

  export let onBack = undefined;
  export let onNext = undefined;
  export let onStep = () => {};

  // TODO open logic below is to work around svelte-select dropdown being hidden by collapse overflow:
  let open = true;

  $: if (!active) {
    open = !active;
  }

  $: executionStyles = classnames({
    'border-success': executionStatus === 'success',
    'border-danger': executionStatus === 'error'
  });
</script>

<Card class="mb-3 {executionStyles}" {...$$restProps}>
  <CardHeader
    class="d-flex justify-content-between {disabled ? 'text-muted' : ''}"
    role="button"
    on:click={() => {
      if (!disabled) {
        onStep();
      }
    }}
    style={disabled ? 'cursor: not-allowed' : undefined}
  >
    <CardTitle class={active ? 'h2' : 'h5'}>{title}</CardTitle>
    <div class="step-header-actions">
      {#if executionStatus === 'error' && debugReport}
        <DebugReport {...debugReport} />
      {/if}
      {#if !active}
        {#if executionStatus === 'success'}
          <Icon name="check-circle" class="text-success" />
        {:else if executionStatus === 'error'}
          <Icon name="x-circle" class="text-danger" />
        {:else if disabled}
          <Icon name="lock" />
        {:else if summary}
          <h5 class="fw-normal text-muted m-0">{summary}</h5>
        {/if}
      {/if}
    </div>
  </CardHeader>

  <Collapse isOpen={active} on:open={() => (open = true)} style={open || 'overflow: hidden'}>
    <CardBody class="pt-3">
      <slot />
    </CardBody>

    <CardFooter class="d-flex justify-content-between">
      {#if onBack}
        <Button color="link" on:click={onBack} class="px-0">
          <Icon name="arrow-left" />
          {$format('label.BACK')}
        </Button>
      {:else}
        &nbsp;
      {/if}

      {#if onNext}
        <Button color="primary" disabled={nextDisabled} on:click={onNext}>
          {#if nextLabel}
            {$format(nextLabel)}
          {:else}
            {$format('label.NEXT')}
            <Icon name="arrow-right" />
          {/if}
        </Button>
      {/if}
    </CardFooter>
  </Collapse>
</Card>

<style>
  .step-header-actions {
    align-items: center;
    display: flex;
    gap: 12px;
  }
</style>
